import clsx from 'clsx'
import React, { ReactNode } from 'react'

type Props = {
  children: JSX.Element | ReactNode
  className?: string
  onClick: () => void
  selected: boolean
}
const ChipButton = ({ children, className = '', onClick, selected }: Props) => {
  return (
    <button
      className={clsx(
        'mr-1 rounded-2xl border border-grey-200 py-1 px-3 text-sm md:text-p-sm',
        selected && 'border-2 bg-grey-100 border-grey-1000',
        className,
      )}
      onClick={onClick}
    >
      {children}
    </button>
  )
}

export default ChipButton
